import axios from "axios";
import { deepMapEntries } from "shared/utils/deepMapEntries";
import { baseApiService } from "..";

class LogsInterceptor {
  constructor() {
    this.onRejected = this.onRejected.bind(this);
    this.onFulfilled = this.onFulfilled.bind(this);
  }
  _formatPayload(payload) {
    if (!payload) return "No payload";
    const keywords = [
      "storeAttachment",
      "updateAttachment",
      "deleteAttachment",
      "file",
    ];
    const keywordRgx = new RegExp(keywords.join("|"), "gi");

    if (payload instanceof FormData) {
      return Object.fromEntries(
        // @ts-ignore
        Array.from(payload.entries()).map(([key, value]) => {
          const isAttachment = keywordRgx.test(key);
          if (isAttachment) {
            return [
              key,
              {
                name: value?.name,
                type: value?.type,
              },
            ];
          }
          return [key, value];
        })
      );
    } else if (typeof payload === "string") {
      return deepMapEntries(JSON.parse(payload), ([key, value]) => {
        const isAttachments = keywordRgx.test(key);
        if (isAttachments) {
          return [
            key,
            key.startsWith("store") || key.startsWith("update")
              ? "[base64]"
              : value,
          ];
        }
        return [key, value];
      });
    }
    return payload;
  }
  onFulfilled(response) {
    return response;
  }
  async onRejected(error) {
    if (error.status === 500) {
      try {
        await axios.post(baseApiService.ENDPOINTS.logs.write, {
          message: error.response?.data?.message,
          level: "error",
          context: [
            "BaseURL => ",
            error.config?.baseURL,
            "Endpoint => ",
            error.config?.url,
            "Payload => ",
            this._formatPayload(error.config?.data),
            "Headers => ",
            error.config?.headers,
          ],
        });
      } catch (error) {
        console.error(error);
      }
    }
    return Promise.reject(error);
  }
}

export const logsInterceptor = new LogsInterceptor();
